import React from 'react';

const JournalPanel = ({
  visit,
  journals = [],
}) => {

    const journalCount = journals.length;

    const totalAdjustedCharge = journals.reduce(
        (sum, j) => sum + (Number(j.adjusted_charge) || 0),
        0
    );
    
  return (
    <div className="discounts-panel">    
        <div
        style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            marginBottom: '12px',
        }}
        >
        <h4 style={{ margin: 0 }}>
            Journals
            <span style={{ fontWeight: 'normal', color: '#666', marginLeft: '8px' }}>
            ({journalCount})
            </span>
        </h4>

        <div style={{ fontSize: '0.85rem', color: '#2e7d32', fontWeight: 500 }}>
            Total Recovered: ${totalAdjustedCharge.toFixed(2)}
        </div>
        </div>

      {journals.length === 0 ? (
        <p>No journals available.</p>
      ) : (
        journals.map((item, idx) => (
          <div
            key={item.id || idx}
            className="charge-capture-card"
            style={{
              borderLeft: '4px solid #1976d2',
              padding: '8px 12px',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '4px',
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '0.85rem', color: '#666' }}>
                <b>{item.charge_type || 'Unknown Charge'}</b>
                {' '}– Recovered Amount: {item.adjusted_charge ?? 0}
                {' '}| {item.label || 'N/A'}
                {item.invoiceitemid ? ` (${item.invoiceitemid})` : ''}
              </div>

              <div style={{ fontSize: '0.85rem', color: '#666' }}>
                Applied By: {item.email}
                {' '}| Missed By: {item.staff_id || 'N/A'}
              </div>

              {item.note && (
                <div style={{ fontSize: '0.8rem', color: '#555' }}>
                  Note: {item.note}
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default JournalPanel;